<template>
  <div id="app">
    <component class="layout" :key="layoutName" :is="layoutName"/>
    <dialogs-wrapper tag="div"></dialogs-wrapper>
  </div>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout'
import EmptyLayout from '@/layouts/EmptyLayout'

export default {
  name: 'App',
  components: {
    'default-layout': DefaultLayout,
    'empty-layout': EmptyLayout
  },
  computed: {
    layoutName () {
      if (!this.$route.matched.length) {
        return null
      }
      const route = Array.from(this.$route.matched).reverse()
        /* eslint-disable no-prototype-builtins */
        .find(item => item.meta.hasOwnProperty('layout'))
      const layout = route ? route.meta.layout : 'default'
      return `${layout}-layout`
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/app.scss';
</style>
